import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" .cls-1 { clip-path: url(#clippath); } .cls-2 { fill: none; stroke-width: 0px; } .cls-3 { fill: #aa1e2d; stroke: #aa1e2d; } .cls-3, .cls-4 { stroke-miterlimit: 10; stroke-width: 1.5px; } .cls-4 { fill: #e0213c; stroke: #e0213c; } ", -1)
        ]))]),
        _: 1
      })),
      _cache[1] || (_cache[1] = _createElementVNode("clipPath", { id: "clippath" }, [
        _createElementVNode("rect", {
          class: "cls-2",
          x: "5.6",
          y: "2.7",
          width: "12.9",
          height: "19"
        })
      ], -1))
    ]),
    _cache[2] || (_cache[2] = _createStaticVNode("<g class=\"cls-1\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><g id=\"Group_1538231968\" data-name=\"Group 1538231968\"><path id=\"Vector\" class=\"cls-3\" d=\"M17.3,17.1V4.1c0-.2-.1-.3-.3-.3H6.9c-.2,0-.3.1-.3.3v13l5.3-3.3,5.3,3.3h0Z\"></path><path id=\"Vector_2\" data-name=\"Vector 2\" class=\"cls-4\" d=\"M17.3,17.2v2.7c0,.2-.2.4-.4.2l-3.4-2.1-.6-.4-.9-.6-.9.6-.6.4-3.4,2.1c-.2.1-.4,0-.4-.2v-2.8l3.7-2.3.7-.4,1-.6,1,.6.7.4,3.7,2.3h0c0,0,0,0,0,0Z\"></path></g></g></g>", 1))
  ]))
}
export default { render: render }